<template>
  <v-time-picker
    v-bind="$props"
    v-on="$listeners"
    :color="color"
    :format="format"
    min="6:00"
    max="20:00"
  ></v-time-picker>
</template>

<script>
import { VTimePicker } from "vuetify/lib";

export default {
  name: "STimePicker",
  extends: VTimePicker,
  props: {
    color: {
      type: String,
      default: "primaryColor",
    },
    format: {
      type: String,
      default: "24hr",
    },
  },
};
</script>

<style></style>
